import { lazyLoad } from 'utils/loadable';

export const NewsListPage = lazyLoad(
  () => import('./index'),
  module => module.NewsListPage,
);
